import React, { JSX } from 'react';

import { enableTextLoaderOnLogin } from 'config/config';

import BrandAnimatedLoadingPlaceholder from 'components/common/atoms/BrandAnimatedLoadingPlaceholder';


import { renderLoadingDetails } from './AppLoadingPlaceholder.helpers';
import Styled from './AppLoadingPlaceholder.styled';
import { AppLoadingPlaceholderProps } from './AppLoadingPlaceholder.types';


function AppLoadingPlaceholder({
    currencies,
    countries,
    companyDetails,
    t,
    accessControl,
    isRefreshingSession,
    isI18nReady,

    asOverlay,
    hideLoadingDetails,
}: AppLoadingPlaceholderProps): JSX.Element {
    return (
        <Styled.AppLoadingPlaceholder data-test-id="app-loading-placeholder" $asOverlay={asOverlay}>
            <BrandAnimatedLoadingPlaceholder />

            {isI18nReady && !hideLoadingDetails && enableTextLoaderOnLogin ? renderLoadingDetails({
                currencies,
                countries,
                companyDetails,
                accessControl,
                isRefreshingSession,
                t,
            }) : undefined }
        </Styled.AppLoadingPlaceholder>
    );
}

export default AppLoadingPlaceholder;

